export default "/images/463037e3c12d93e24ab18c303c797329.avif";